const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

export default {
  dsn:
    SENTRY_DSN ||
    'https://29149d2a9d924cb086bee336e6a13108@sentry.roznanie.ru/3',
  tracesSampleRate: 0.2,
  ignoreErrors: [
    'VK is not defined',
    "Cannot read properties of null (reading 'postMessage')",
    /hydration failed/i,
    /error while hydrating/i,
    /not match server-rendered HTML/i,
    /doesn't support the API's required to use the Firebase SDK/i,
  ],
};
